var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class Banner extends Component {
    constructor() {
        super('Banner', false);
        this.offset = 0;
        this.speed = 1;
        this.width = 0;
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            this.container = $('.component-banner--container');
            this.width = this.container.find('img').width();
            setInterval(() => {
                this.offset += this.speed;
                if (this.offset >= this.width) {
                    this.offset = 0;
                }
                this.container.css('transform', `translateX(-${this.offset}px)`);
            }, 20);
            this.success();
        });
    }
}
